// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","White":"#FFFFFF","Blackberry":"#333D47","arrow":"G1d580b","arrowRight":"G12dc4a","arrowLeft":"G3a6d8d"};